"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { UserStar, Music, ChevronLeft, ChevronRight, ShieldCheck, ListMusic, Trophy } from "lucide-react";
import { useAtom, useAtomValue } from "jotai";
import { isSidebarCollapsedAtom, userAtom } from "@/store/useStore";

export default function Sidebar() {
  const pathname = usePathname();
  const [isCollapsed, setIsCollapsed] = useAtom(isSidebarCollapsedAtom);

  const navItems = [
    {
      name: "Manage Artists",
      href: "/manage-artist",
      icon: UserStar,
    },
    {
      name: "Manage Songs",
      href: "/manage-song",
      icon: Music,
    },
    {
      name: "Song Requests",
      href: "/manage-song-request",
      icon: ListMusic,
    },
    {
      name: "Manage Roles",
      href: "/manage-role",
      icon: ShieldCheck,
    },
    {
      name: "Competitions",
      href: "/manage-competition",
      icon: Trophy,
    },
  ];

  return (
    <aside className={`relative ${isCollapsed ? "w-20" : "w-64"} bg-white border-r border-gray-200 flex flex-col pt-6 transition-all duration-300 ease-in-out`}>
      {/* COLLAPSE TOGGLE BUTTON */}
      <button
        onClick={() => setIsCollapsed(!isCollapsed)}
        className="absolute -right-3 top-2 w-6 h-6 bg-white border border-gray-200 rounded-full flex items-center justify-center shadow-md hover:bg-slate-50 transition-all z-[10] group"
        title={isCollapsed ? "Expand Sidebar" : "Collapse Sidebar"}
      >
        <div className="text-slate-400 group-hover:text-violet-600">
          {isCollapsed ? <ChevronRight size={14} strokeWidth={3} /> : <ChevronLeft size={14} strokeWidth={3} />}
        </div>
      </button>

      {/* NAV */}
      <div className="flex-1 px-3 space-y-2">
        {navItems.map((item) => {
          const isActive =
            pathname === item.href || (item.href !== "/" && pathname.startsWith(item.href + "/"));

          return (
            <Link
              key={item.href}
              href={item.href}
              className={`flex items-center ${isCollapsed ? "justify-center p-3" : "gap-3 px-4 py-3"} rounded-lg transition-all ${isActive
                ? "bg-violet-50 text-violet-600 font-medium"
                : "text-slate-600 hover:bg-slate-50 hover:text-slate-900"
                }`}
              title={isCollapsed ? item.name : ""}
            >
              <item.icon
                className={`w-5 h-5 flex-shrink-0 ${isActive ? "text-violet-600" : "text-slate-400"
                  }`}
              />
              {!isCollapsed && (
                <span className="text-sm whitespace-nowrap overflow-hidden animate-in fade-in slide-in-from-left-1 duration-300">
                  {item.name}
                </span>
              )}
            </Link>
          );
        })}
      </div>
    </aside>
  );
}